import { render, staticRenderFns } from "./configIndex.vue?vue&type=template&id=31459f2a&scoped=true"
import script from "./configIndex.vue?vue&type=script&lang=js"
export * from "./configIndex.vue?vue&type=script&lang=js"
import style0 from "./configIndex.vue?vue&type=style&index=0&id=31459f2a&prod&lang=css"
import style1 from "./configIndex.vue?vue&type=style&index=1&id=31459f2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31459f2a",
  null
  
)

export default component.exports